import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TutorialInputModel } from 'src/app/core/model/input/tutorial-input-model';

@Injectable()
export class TutorialShared {
  constructor() {}

  private _selectedTutorial: TutorialInputModel;
  private _tutorialStep: number;

  private _calendarBox: HTMLElement;
  private _cheatDayBox: HTMLElement;
  private _calorieChartBox: HTMLElement;

  private _noDietBox: HTMLElement;

  private _settingBox: HTMLElement;
  private _reportsBox: HTMLElement;

  private _packageBox: HTMLElement;
  private _changeMealBox: HTMLElement;
  private _consumeMealBox: HTMLElement;
  private _foodBox: HTMLElement;
  private _addFoodBox: HTMLElement;

  public get changeMealBox(): HTMLElement {
    return this._changeMealBox;
  }
  public set changeMealBox(value: HTMLElement) {
    this._changeMealBox = value;
  }

  public get consumeMealBox(): HTMLElement {
    return this._consumeMealBox;
  }
  public set consumeMealBox(value: HTMLElement) {
    this._consumeMealBox = value;
  }

  public get foodBox(): HTMLElement {
    return this._foodBox;
  }
  public set foodBox(value: HTMLElement) {
    this._foodBox = value;
  }

  public get addFoodBox(): HTMLElement {
    return this._addFoodBox;
  }
  public set addFoodBox(value: HTMLElement) {
    this._addFoodBox = value;
  }

  public get packageBox(): HTMLElement {
    return this._packageBox;
  }
  public set packageBox(value: HTMLElement) {
    this._packageBox = value;
  }

  public get settingBox(): HTMLElement {
    return this._settingBox;
  }
  public set settingBox(value: HTMLElement) {
    this._settingBox = value;
  }

  public get reportsBox(): HTMLElement {
    return this._reportsBox;
  }
  public set reportsBox(value: HTMLElement) {
    this._reportsBox = value;
  }

  public get noDietBox(): HTMLElement {
    return this._noDietBox;
  }
  public set noDietBox(value: HTMLElement) {
    this._noDietBox = value;
  }

  public get calorieChartBox(): HTMLElement {
    return this._calorieChartBox;
  }
  public set calorieChartBox(value: HTMLElement) {
    this._calorieChartBox = value;
  }

  public get cheatDayBox(): HTMLElement {
    return this._cheatDayBox;
  }
  public set cheatDayBox(value: HTMLElement) {
    this._cheatDayBox = value;
  }

  public get calendarBox(): HTMLElement {
    return this._calendarBox;
  }
  public set calendarBox(value: HTMLElement) {
    this._calendarBox = value;
  }

  public get tutorialStep(): number {
    return this._tutorialStep;
  }
  public set tutorialStep(value: number) {
    this._tutorialStep = value;
  }

  public get selectedTutorial(): TutorialInputModel {
    return this._selectedTutorial;
  }
  public set selectedTutorial(value: TutorialInputModel) {
    this._selectedTutorial = value;
  }

  private showTutorialObs = new BehaviorSubject<boolean>(false);
  showTutorialObs$ = this.showTutorialObs.asObservable();

  private hideTutorialObs = new BehaviorSubject<boolean>(false);
  hideTutorialObs$ = this.hideTutorialObs.asObservable();

  showTutorial() {
    this.showTutorialObs.next(true);
    this.showTutorialObs.next(false);
  }

  hideTutorial() {
    this.hideTutorialObs.next(true);
    this.hideTutorialObs.next(false);
  }
}
